import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

import Link from 'components/common/Link';

const styles = () => ({
  root: {
    position: 'absolute',
    bottom: 25,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  link: {
    margin: '0 20px',
    whiteSpace: 'nowrap',
  },
});

const AccountNavigation = ({ classes }) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <Link
      className={classes.link}
      size="lg"
      color="secondary"
      href="/privacy-policy"
    >
      Privacy Policy
    </Link>
    <Link
      className={classes.link}
      size="lg"
      color="secondary"
      href="/terms-of-use"
    >
      Terms of Use
    </Link>
  </Toolbar>
);

AccountNavigation.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(AccountNavigation);



// WEBPACK FOOTER //
// ./src/components/account/AccountNavigation/AccountNavigation.js